// Tenant country context for address fields.
//
// The address block needs to know which country it is describing so it can
// offer the right regions, use the right word for them ("Emirate", not
// "State"), and apply the right postal-code rule. Left alone it assumed India
// everywhere — the reported symptom was an Omani supplier form listing Andhra
// Pradesh, Assam and Bihar.
//
// Derived from the tenant's immutable currency via the frozen CURRENCY_COUNTRY
// table in `@bbpos/types`, the same source the dial code and tax regime use, so
// there is exactly one currency -> country mapping in the codebase. Returns
// India before the auth profile hydrates (useTenantCurrency defaults to INR),
// which keeps every INR tenant byte-identical.

import { getCountryForCurrency } from '@bbpos/types';
import type { TenantCountry } from '@bbpos/types';

import { useTenantCurrency } from './use-tenant-currency';

/** Hook: the country the current tenant operates in, e.g. Oman for an OMR tenant. */
export function useTenantCountry(): TenantCountry {
  return getCountryForCurrency(useTenantCurrency());
}
